import { createRouter, createWebHistory } from 'vue-router'

import routes from './routes'

const router = createRouter({
  history: createWebHistory(),
  // @ts-expect-error todo fix me
  routes,
})

router.beforeEach((to, from, next) => {
  document.title = to.meta?.title ? `${to.meta.title} | Metapic Advertiser` : 'Metapic Advertiser'
  next()
})

export default router
